import React from 'react';

export default function TwoColumnIcon() {
  return (
    <svg
      width='24'
      height='18'
      viewBox='0 0 24 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M0 0H13V18H0V0Z' fill='black' />
      <path d='M27.7391 14V17.5H16V14H27.7391Z' fill='black' />
      <path d='M27.7391 0V3.5H16V0H27.7391Z' fill='black' />
      <path d='M27.7391 7.5V11H16V7.5H27.7391Z' fill='black' />
    </svg>
  );
}
